import BackToDashboard from 'modules/SeniorSurvey/modals/BackToDashboard';

export default {
  BACK_TO_DASHBOARD_MODAL: BackToDashboard,
};
